import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { BaseAPI } from 'src/providers/base-api';

const TOKEN_CHECK_INTERVAL = 15 * 60 * 1000;
const MAX_CONSECUTIVE_UNAUTHORIZED = 5;

export const useAxiosInterceptor = () => {
    const navigate = useNavigate();
    let consecutiveUnauthorized = 0;

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (response) => {
                consecutiveUnauthorized = 0;
                return response;
            },
            (error) => {
                if (error.response && error.response.status === 401) {
                    consecutiveUnauthorized += 1;
                    if (consecutiveUnauthorized >= MAX_CONSECUTIVE_UNAUTHORIZED) {
                        sessionStorage.clear();
                        // Check if current path is client portal - redirect accordingly
                        const isClientPortal = window.location.pathname.startsWith('/portal');
                        navigate(isClientPortal ? '/portal/login' : '/login');
                    }
                }
                return Promise.reject(error);
            }
        );

        const checkRedisToken = async () => {
            try {
                const response = await BaseAPI.validateToken();
                if (!response || !response.data) {
                    sessionStorage.clear();
                    // Check if current path is client portal - redirect accordingly
                    const isClientPortal = window.location.pathname.startsWith('/portal');
                    navigate(isClientPortal ? '/portal/login' : '/login');
                }
            } catch (error) {
                console.error('Error checking token:', error);
                sessionStorage.clear();
                // Check if current path is client portal - redirect accordingly
                const isClientPortal = window.location.pathname.startsWith('/portal');
                navigate(isClientPortal ? '/portal/login' : '/login');
            }
        };

        const intervalId = setInterval(checkRedisToken, TOKEN_CHECK_INTERVAL);

        return () => {
            axios.interceptors.response.eject(interceptor);
            clearInterval(intervalId);
        };
    }, [navigate]);
};
